// @flow
import config from '../../config';
import { makeAPICall, APIError } from '../generalCreators';
import { updateCurrentIndustry } from './currentIndustryCreators';
import type { ThunkAction, Industry } from '../../types';

export function getIndustries(
  isAllocatedTo: boolean = true,
  excludeArchived: boolean = false
): ThunkAction {
  return function(dispatch, getState) {
    const endpoint = '/industries';
    const options = {
      method: 'GET',
      headers: { token: getState().authentication.token },
      params: {
        productId: config.productId,
        isAllocatedTo,
        excludeArchived
      }
    };
    return makeAPICall(endpoint, options).then(
      response =>
        dispatch({
          type: 'UPDATE_INDUSTRIES',
          industries: response.data.industries
        }),
      error => dispatch(APIError(error, 'Error getting Industries'))
    );
  };
}

export function getIndustry(industryId: number): ThunkAction {
  return function(dispatch, getState) {
    const endpoint = `/industry/${industryId}`;
    const options = {
      method: 'GET',
      headers: { token: getState().authentication.token },
      params: { productId: config.productId }
    };

    return makeAPICall(endpoint, options).then(
      response => response.data.industry,
      error => dispatch(APIError(error, 'Error getting Industry'))
    );
  };
}

export function addIndustry(industry: Industry): ThunkAction {
  return function(dispatch, getState) {
    const endpoint = '/industries';
    const options = {
      method: 'POST',
      headers: { token: getState().authentication.token },
      params: { productId: config.productId },
      data: industry
    };

    return makeAPICall(endpoint, options).then(
      response => {
        const newIndustryId = response.data.id;
        dispatch(getIndustries());
        dispatch(updateCurrentIndustry(newIndustryId));
        return response;
      },
      error => dispatch(APIError(error, 'Error creating Industry'))
    );
  };
}

export function updateIndustry(industry: Industry): ThunkAction {
  return function(dispatch, getState) {
    const endpoint = `/industry/${industry.id}`;
    const options = {
      method: 'PUT',
      headers: { token: getState().authentication.token },
      params: { productId: config.productId },
      data: industry
    };
    return makeAPICall(endpoint, options).then(
      response => {
        dispatch(getIndustries());
        dispatch(updateCurrentIndustry(industry.id));
        return response;
      },
      error => dispatch(APIError(error, 'Error updating Industry'))
    );
  };
}



// WEBPACK FOOTER //
// ./src/actions/industries/basicCreators.js